<template>
  <div class="sales-rep-widget-scroll table-responsive p-3">
    <table class="table table-bordered table-sm sales-rep-widget-table mb-0">
      <thead>
        <tr>
          <th>Opp Type</th>
          <th>Org Name</th>
          <th>Opp Num</th>
          <th>{{ nextUpdateColumnTitle }}</th>
          <th>Description</th>
          <th>Pipeline</th>
        </tr>
      </thead>
      <tbody v-if="items.length">
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.opp_type || '—' }}</td>
          <td>{{ item.organization_name || '—' }}</td>
          <td>
            <router-link
              v-if="item.id"
              :to="oppLink(item)"
              class="text-teal"
            >
              {{ item.opportunity_number || '—' }}
            </router-link>
            <span v-else>{{ item.opportunity_number || '—' }}</span>
          </td>
          <td>{{ item.next_update_display || '—' }}</td>
          <td class="sales-rep-desc-cell">
            <div class="sales-rep-cell-content sales-rep-cell-content--wide">{{ item.description || '—' }}</div>
          </td>
          <td>{{ item.pipeline || '—' }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="6" class="text-center text-muted py-3">{{ emptyMessage }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'SalesRepCallbackWidgetTable',
  props: {
    items: { type: Array, default: () => [] },
    mode: { type: String, default: 'time' }, // 'time' | 'date'
    emptyMessage: { type: String, default: 'No data' },
  },
  setup(props) {
    const nextUpdateColumnTitle = computed(() =>
      props.mode === 'time' ? 'Next Update Latest (TIME)' : 'Next Update Latest (DATE)'
    );

    const oppLink = (item) => ({
      path: `/crm/meter-opportunities-edit/${item.id}`,
      query: { add: 'dashboard', for: 'opportunities' },
    });

    return { nextUpdateColumnTitle, oppLink };
  },
};
</script>
